export default __webpack_public_path__ + "static/media/GHNI.94e3ced3.png";